import React, { useState, useEffect } from "react";
import Topheader from "./topheader/Topheader";
import Navbar from "./navbar/Navbar";
import Header from "./header/Header";
import Detailpage from "./detailspage/Detailpage";
import Aboutpage from "./aboutpage/Aboutpage";
import Careersection from "./careersection/Careersection";
import Enquirypage from "./enquirpage/Enquirypage";
import Contactpage from "./contact/Contactpage";
import Coursedetailpage from "./coursedetailpage/Coursedetailpage";
// import Popupbox from "./popupbox/Popupbox";
import Popupboxbox from "./popupbox/Popupbox";
import ScrollToTop from "../ScrollToTop";
import FooterMain from "./footer/Footer";


function Maincomponent() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const popupShown = sessionStorage.getItem("popupShown");

    if (!popupShown) {
      const timer = setTimeout(() => {
        setIsPopupOpen(true);
        sessionStorage.setItem("popupShown", "true");
      }, 9000);

      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <div className="w-full min-h-screen bg-white font-sans antialiased">
    <ScrollToTop/>
      {/* Popup */}
      <Popupboxbox
        isOpen={isPopupOpen}
        onClose={closePopup}
      />

      <Topheader />
      <Navbar />
      <Header />
      <Detailpage />
      <Aboutpage />
      <Coursedetailpage />
      <Careersection />
      <Enquirypage />
      <Contactpage />
      <FooterMain/>

    </div>
  );
}

export default Maincomponent;